import React, { useState, useCallback, useRef, useMemo } from "react";
import { FTLPaginationButton } from "./FTLPaginationButton";
import { Box, makeStyles, List, ListItem, } from "@material-ui/core";
import { typography } from "../../shared/theme";
import { ArrowDownIcon } from "../icons/ArrowDown";
import { FTLTypography } from "../FTLTypography";
import { FTLDropdownMenuWithController, } from "../FTLDropdownMenu";
const FTLTableSelect = ({ pageSize, setPageSize, pageCount = 50 }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const pageSizeContainerRef = useRef(null);
    const pageSizes = [5, 10, 20, 30, 40, 50].filter((value) => value <= pageCount + 10);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.pageSizeContainer, ref: pageSizeContainerRef },
            React.createElement(FTLTypography, { variant: "listItemText", component: "div" },
                "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:",
                React.createElement(FTLDropdownMenuWithController, { open: open, onClick: () => setOpen(true), onClickOutside: () => setOpen(false), placement: "bottom", controller: React.createElement(Box, { display: "inline-flex", className: classes.pageSizeWrapper },
                        pageSize,
                        React.createElement(ArrowDownIcon, { color: "secondary", className: classes.pageSizeIcon })) },
                    React.createElement(List, { disablePadding: true }, pageSizes.map((value) => (React.createElement(ListItem, { button: true, key: value, onClick: (e) => {
                            setPageSize(value);
                            setOpen(false);
                        }, className: classes.listItem }, value)))))))));
};
const getVisiblePages = (pageIndex, totalPages, maxPages = 5) => {
    let pages = [];
    const nextPageNumber = pageIndex + 2;
    const startPage = nextPageNumber > maxPages && totalPages > maxPages
        ? totalPages < nextPageNumber
            ? totalPages - maxPages + 1
            : nextPageNumber - maxPages + 1
        : 1;
    for (let i = 0; i < maxPages; i++) {
        if (i + startPage > totalPages)
            break;
        pages.push(i + startPage);
    }
    return pages;
};
export const FTLTableFooter = ({ pageIndex, pageSize, pageCount, setPageSize, gotoPage = () => { }, }) => {
    const classes = useStyles();
    const pages = Math.ceil(pageCount / pageSize);
    const getPages = useCallback((page) => {
        if (pages < page)
            return getVisiblePages(pages, pages);
        else
            return getVisiblePages(page, pages);
    }, [pageSize, pageCount]);
    const pageComponents = useMemo(() => {
        const visiblePages = getPages(pageIndex);
        return visiblePages.map((pageNumber) => {
            return (React.createElement(FTLPaginationButton, { isSelected: pageIndex + 1 === pageNumber, disabled: pageNumber > pages, onClick: () => {
                    if (pageIndex + 1 !== pageNumber) {
                        gotoPage(pageNumber);
                    }
                }, key: pageNumber }, pageNumber));
        });
    }, [getPages, pageIndex]);
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Box, { display: "flex", className: classes.container }, pageCount ? (React.createElement(React.Fragment, null,
            React.createElement(FTLTypography, { variant: "listItemText" }, `Всего: ${pageCount}`),
            React.createElement(Box, { marginLeft: 6 },
                React.createElement(FTLTypography, { variant: "listItemText" },
                    React.createElement(FTLTableSelect, { pageSize: pageSize, setPageSize: (value) => {
                            gotoPage(1);
                            setPageSize(value);
                        }, pageCount: pageCount }))))) : null),
        pageIndex + 2 >= 5 && pages > 5 && (React.createElement(FTLPaginationButton, { onClick: () => {
                gotoPage(1);
            }, style: { width: "86px", marginLeft: "auto" } }, "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E")),
        React.createElement(Box, { display: "flex", className: classes.paginationContainer },
            pages > 1 ? pageComponents : null,
            pages > 5 && (React.createElement(FTLPaginationButton, { disabled: pages < 5 || pageIndex + 1 >= pages, style: { width: "68px", marginRight: "0" }, onClick: () => {
                    gotoPage(pageIndex + 2);
                } }, "\u0414\u0430\u043B\u0435\u0435")))));
};
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "80px",
        boxShadow: "0 -4px 0 -2px #ebedf0",
    },
    container: {
        alignItems: "center",
    },
    pageSizeContainer: {
        display: "flex",
        alignItems: "center",
    },
    pageSizeWrapper: {
        cursor: "pointer",
        marginLeft: "8px",
    },
    pageSizeIcon: {
        marginLeft: "16px",
        width: "20px",
        height: "20px",
    },
    paginationContainer: {
        "& > button": {
            width: "32px",
            margin: "4px",
        },
    },
    listItem: Object.assign(Object.assign({}, typography.unsupportedSemanticTags.listItemText), { backgroundColor: "#fff", color: theme.palette.text.primary, cursor: "pointer", outline: "none", "&:hover": {
            backgroundColor: "#f5f5f6",
        } }),
}));
//# sourceMappingURL=FTLTableFooter.js.map